import { createFileRoute } from '@tanstack/react-router';

import { InvestorLoginPage, requireLoginBranch } from '@/features/investor-login/public';

export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => requireLoginBranch(context.queryClient),
  component: InvestorLoginPage,
});
